export const BASE_PARAMS = {
    'Source Component': 'Collect Menu'
};
